import styled from "styled-components";
import Label from "../label/label.component.js";
import {LabelContainer} from "../label/label.styles.js";
import {getLineHeight, parseSize, transformSize} from "../../../common/generic-react.functions.js";
export const CheckboxContainer = styled.div.withConfig({
  displayName: "checkboxstyles__CheckboxContainer",
  componentId: "sc-fkjb4p-0"
})(["", " .checkbox__error{font-size:", ";line-height:", ";padding-left:", "px;", ";}"], {
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "column",
  width: "auto"
}, ({
  size
}) => parseSize(transformSize(size, -1)), ({
  size
}) => `${getLineHeight(transformSize(size, -1))}`, ({
  size
}) => +parseSize(size, true) * 2, {
  color: "var(--errorColor)"
});
export const CheckboxLabelContainer = styled(Label).withConfig({
  displayName: "checkboxstyles__CheckboxLabelContainer",
  componentId: "sc-fkjb4p-1"
})(["", " font-size:", ";line-height:", ";", " ", " ", "{", "}", ",div.checkbox{", " ", " ", " ", "}input:checked ~ div.checkbox:after{", "}div.checkbox{", " height:", ";width:", ";min-height:", ";min-width:", ";", " ", " ", " ", ";&:after{", " content:'';background-color:", ";margin:1px;width:", "px;height:", "px;}}"], {
  display: "flex",
  alignItems: "center",
  overflowWrap: "break-word",
  "--tw-text-opacity": "1",
  color: "rgba(42, 57, 78, var(--tw-text-opacity))"
}, ({
  size
}) => parseSize(size), ({
  size
}) => getLineHeight(size), ({
  disabled
}) => disabled && {
  opacity: "0.5",
  cursor: "not-allowed"
}, ({
  readOnly
}) => !readOnly && {
  cursor: "pointer"
}, LabelContainer, ({
  position
}) => position === "left" ? {
  paddingRight: "0px",
  textAlign: "left"
} : {
  paddingLeft: "0px",
  textAlign: "right"
}, LabelContainer, {
  paddingTop: "0px",
  paddingBottom: "0px"
}, ({
  readOnly
}) => readOnly && {
  cursor: "default"
}, ({
  disabled
}) => disabled && {
  cursor: "not-allowed"
}, ({
  disabled,
  readOnly
}) => !disabled && !readOnly && {
  cursor: "pointer"
}, {
  display: "block"
}, {
  borderRadius: "0.125rem",
  position: "relative",
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  paddingTop: "0px",
  paddingBottom: "0px",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "var(--tertiaryColor)"
}, ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  size
}) => parseSize(size), ({
  readOnly
}) => readOnly && {
  cursor: "default"
}, ({
  disabled
}) => disabled && {
  cursor: "not-allowed"
}, ({
  disabled,
  readOnly
}) => !disabled && !readOnly && {
  cursor: "pointer"
}, ({
  errorMessage
}) => errorMessage && {
  borderColor: "var(--errorColor)"
}, {
  borderRadius: "0.125rem",
  display: "none"
}, ({
  color
}) => color, ({
  size
}) => +parseSize(size, true) - 4, ({
  size
}) => +parseSize(size, true) - 4);
